let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cVPRM")).then(() => parcelRequire('b89lR'));